module.exports = __webpack_public_path__ + "static/mr-press-33-6ecf17b5d2810b2bd505893c140b0978.jpg";